export default __webpack_public_path__ + "static/outsource@mob-ca08736cf0e99c519a76cf67b2e7d97b.png";